export default __webpack_public_path__ + "5dfb846c033fb8dcff45ed9abbd8aa95.webp";